// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"0d665bd3","595":"e1f2aac5","604":"f3c0a7e5","629":"1f48d519","946":"a61b33ed"}[chunkId] + ".chunk.js";
};